import {useEffect, useState} from "react";

const STORAGE_KEY = "neuron:viewInterceptorDebug";

const readEnabled = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "true";
};

export const useDebugMode = () => {
  const [enabled, setEnabled] = useState(readEnabled);

  useEffect(() => {
    const handler = (event) => {
      if (typeof event.detail?.enabled === "boolean") {
        setEnabled(event.detail.enabled);
      }
    };
    window.addEventListener("viewInterceptorToggle", handler);
    return () => window.removeEventListener("viewInterceptorToggle", handler);
  }, []);

  return enabled;
};
